import { Component, inject, OnInit } from "@angular/core";
import { MarketService } from "../../../../../../shared/src/lib/services/market.service";
import { RouterLink } from "@angular/router";
import { AsyncPipe } from "@angular/common";
import { AlertComponent } from "../../../components/alert/alert.component";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";
import { Observable, Subject } from "rxjs";
import { SportsLoaderComponent } from "./sports-loader/sports-loader.component";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-sports",
  imports: [RouterLink, AlertComponent, AsyncPipe, SportsLoaderComponent],
  templateUrl: "./sports.component.html",
  styleUrl: "./sports.component.scss",
})
export class SportsComponent implements OnInit {
  sports: any[] = [];
  sportsService = inject(MarketService);
  loader = inject(LoaderService);
  $loading!: Observable<boolean>;
  readonly destroy$ = new Subject<void>();

  ngOnInit() {
    this.$loading = this.loader.isLoading("/navigation/sports");
    this.getSports();
  }

  getSports() {
    this.sportsService.sports$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.sports = result;
    });
  }
}
